<template>
  <InformationBasicSuivi :typeActiviteAfficher="typeActiviteAfficher" :confidentialiteAfficher="confidentialiteAfficher"
  :statutAfficher="statutAfficher" :texte="texte" :secteurAssigneAfficher="secteurAssigneAfficher"
  :secteurCreateurAfficher="secteurCreateurAfficher" :intervenantAfficher="intervenantAfficher"
  :creerLe="creerLe" :completee="completee" :prevue="prevue"
  :creerParDescription="creerParDescription" :isDataLoading="isDataLoading"/>
  <ButtonBarSuivi :modifiable="modifiable" @approuver="approuver" :approuvable="approuvable" @fermer="fermer"/>
</template>

<script>
import ButtonBarSuivi from '../../../components/dossier/Consulter/ButtonBarSuivi.vue'
import InformationBasicSuivi from '../../../components/dossier/Consulter/InformationBasicSuivi.vue'
import axios from 'axios';
import {mapGetters} from 'vuex';

export default {
  name: 'ConsulterSuivi',
  components: {
    InformationBasicSuivi,
    ButtonBarSuivi,
  },
  mounted() {
    this.isDataLoading = true;

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Consulter un Suivi");
    this.getSuivi();
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      actionAccesDecision: "dossier/actionAccesDecision"
    })
  },
  data() {
    return {
      isDataLoading: false,
      typeActiviteAfficher: null,
      confidentialiteAfficher: null,
      statutAfficher: null,
      texte: null,
      secteurAssigneAfficher: null,
      secteurCreateurAfficher:null,
      intervenantAfficher: null,
      creerLe: null,
      completee: null,
      prevue: null,
      creerParDescription: null,
      approuverParAfficher:null,
      modifiable: null,
      approuvable: null,
      suiviPourApprobation: {}
    };
  },
  methods: {
    assignerSuivi(res) {
      this.typeActiviteAfficher = res.data.entite.typeActiviteAfficher;
      this.confidentialiteAfficher = res.data.entite.confidentialiteAfficher;
      this.statutAfficher = res.data.entite.statutAfficher;
      this.texte = res.data.entite.texte;
      this.secteurAssigneAfficher = res.data.entite.secteurAssigneAfficher;
      this.secteurCreateurAfficher = res.data.entite.secteurCreateurAfficher;
      this.intervenantAfficher = res.data.entite.intervenantAfficher;
      this.creerLe = res.data.entite.creerLe;
      this.completee = res.data.entite.completee;
      this.prevue = res.data.entite.prevue;
      this.creerParDescription = res.data.entite.creerParDescription;
      this.approuverParAfficher = res.data.entite.approuverParAfficher;
      this.modifiable = res.data.entite.modifiable;
      this.approuvable = res.data.entite.approuvable;
      this.suivi = res.data.entite;
    },
    getSuivi() {
      this.$store
        .dispatch("suivi/consulterSuiviAction", {
          cle: this.$route.params.cle,
          site: this.$route.params.site
        })
        .then((res) => {
          this.assignerSuivi(res);
          this.isDataLoading=false;
        });
    },
    addMessage(messageList) {
      if (messageList && messageList.length > 0) {
        messageList.forEach(m => {
          if (!m.severite) {
            m.severite = 'warn'
          }
        })
      }
      this.$root.$refs.messagesComp.messagesList = messageList
    },
    approuver() {
      this.isDataLoading = true;
      let erreurSauvegarde = false;
      this.$store.dispatch('suivi/approuverSuiviAction', {
        cle: this.$route.params.cle,
        site: this.$route.params.site,
        genre: 'DO',
      })
          .then((res) => {
            this.$root.$refs.messagesComp.messages.splice(0);
            if (res.status == 200 || res.status == 202) {
              this.addMessage(res.data.messageVOs);
              res.data.messageVOs.forEach(elem => {
                if (elem.severite == "error") {
                  erreurSauvegarde = true;
                }
              });
              if (erreurSauvegarde) {
                this.$toast.add(
                    {
                      severity: 'error', summary: 'Approbation',
                      detail: 'Une erreur est survenue lors de l\'approbation', life: 6000
                    });
              } else {
                this.getSuivi();
                this.$toast.add(
                    {
                      severity: 'success', summary: 'Approbation',
                      detail: 'Le suivi a été approuvé.', life: 6000
                    });
              }
            } else {
              this.$toast.add(
                  {
                    severity: 'error',
                    summary: 'Approbation',
                    detail: 'Une erreur est survenue lors de l\'approbation.',
                    life: 6000
                  });
            }
            this.isDataLoading = false;
          });
    },
    fermer() {
        this.$root.$refs.breadcrumbComp.rediriger();
    },
  },
};
</script>